import React from 'react';
import type { NavItem } from 'baseui/app-nav-bar';
import { Grid } from 'baseui/layout-grid';
import Batch from './batch';
import BatchTasks from './batch-tasks';
import DoDMediaIngestion from './dod-media-ingestion';
import Header from './header';
import Project from './project';
import UserGroup from './user-group';
const getActiveItemComponent = (item: NavItem) => {
  switch (item.label) {
    case 'User':
      const activeChild = item.children?.find(child => child.active);
      return <UserGroup active={activeChild?.label || ''} />;
    case 'Batch':
      return <Batch />;
    case 'Project':
      return <Project />;
    case 'DoD Media Ingestion':
      return <DoDMediaIngestion />;
    case 'Tasks':
      return <BatchTasks />;
    default:
      return null;
  }
};
const AdminPage = () => {
  const [mainItems, setMainItems] = React.useState<NavItem[]>([{
    label: 'User',
    active: true,
    children: [{
      label: 'User Management',
      active: true
    }, {
      label: 'User Group Management'
    }]
  }, {
    label: 'Tasks'
  }, {
    label: 'Batch'
  }, {
    label: 'Project'
  }, {
    label: 'DoD Media Ingestion'
  }]);
  const activeItem = mainItems.find((item: NavItem) => item.active);
  return <div>
      <Header mainItems={mainItems} setMainItems={setMainItems} />
      <Grid>{activeItem && getActiveItemComponent(activeItem)}</Grid>
    </div>;
};
export default AdminPage;